import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getQuotations } from '../../../shared/api/quotations.api'
import { KPPanel } from './KPPanel'

interface Props {
  requestId: string
}

/**
 * Full-width аккордеон с историей КП. По умолчанию свёрнут, чтобы не
 * распирать страницу при большом количестве снапшотов. Счётчик в шапке
 * тянется тем же useQuery что и сам список — без дублирующего запроса.
 */
export function KPAccordion({ requestId }: Props) {
  const [expanded, setExpanded] = useState(false)

  const { data: quotations = [] } = useQuery({
    queryKey: ['quotations', requestId],
    queryFn: () => getQuotations(requestId),
  })

  return (
    <div className="bg-white rounded-xl border border-gray-200">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors rounded-xl"
        aria-expanded={expanded}
      >
        <span className="flex items-center gap-2">
          <svg
            className={`w-4 h-4 transition-transform ${expanded ? 'rotate-90' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          КП
          <span className="text-gray-400 font-normal">({quotations.length})</span>
        </span>
        {!expanded && quotations.length > 0 && (
          <span className="text-xs text-gray-400">
            Последнее:{' '}
            {new Date(quotations[0]!.createdAt).toLocaleDateString('ru-RU', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })}
          </span>
        )}
      </button>
      {expanded && (
        <div className="px-4 pb-4 border-t border-gray-100 pt-3">
          <KPPanel requestId={requestId} />
        </div>
      )}
    </div>
  )
}
